import { UnknownAction } from '@reduxjs/toolkit';
import {
  CHECK_NEW_MESSAGES,
  MessagesActionTypes,
  CheckNewMessagesAction,
} from '../types/redux/actions';
import { MessagesState } from '../types/redux/state';

const initialState: MessagesState = {
  hasNew: false,
};

const messagesReducer = (
  state = initialState,
  action: MessagesActionTypes | UnknownAction,
): MessagesState => {
  switch (action.type) {
    case CHECK_NEW_MESSAGES:
      return {
        ...state,
        hasNew: (action as CheckNewMessagesAction).payload,
      };

    default:
      return state;
  }
};

export default messagesReducer;
